import React from 'react';
import Table from 'shared/Table';
import { Typography } from '@mui/material';
import { useAppSelector } from 'core/store';
import { TRow } from 'shared/Table/Table.models';
import { useTableContext } from 'shared/Table/TableContext';
import { useUpdateEffect } from 'core/hooks/useUpdateEffect';
import { useSellerDepartmentContext } from '@dashboardWirelineSellerDepartment/SellerDepartmentContext';
import ExportBookingTable from '@dashboardWireline/WirelineDepartments/SellerDepartment/BookingInfo/ExportBookingTable';
import { BookingActionButton, BookingReportFilter } from '@dashboardWirelineSellerDepartment/BookingInfo/BookingTableTopToolbar';

interface IBookingTableProps {
  reportPeriod: string | null
  isLoadingTableFiltersData: boolean
  setReportPeriod: (reportPeriod: string | null) => void;
}

const BookingTable: React.FC<IBookingTableProps> = ({
  reportPeriod, setReportPeriod, isLoadingTableFiltersData,
}) => {
  const { getTableData } = useTableContext();
  const { actionsPermissions } = useSellerDepartmentContext();

  const {
    isAvailableExportTable,
    isAvailableGetBookingReport,
  } = actionsPermissions;

  const isLoadingTableData = useAppSelector((state) => state.dashboard.bookingTableData.isLoading);
  const bookingDataCount = useAppSelector((state) => state.dashboard.bookingTableData.count);
  const bookingData = useAppSelector((state) => state.dashboard.bookingTableData.results);

  const isLoading = isLoadingTableData || isLoadingTableFiltersData;

  const bottomToolbarCustomActions = isAvailableExportTable ? () => (
    <ExportBookingTable
      reportPeriod={reportPeriod}
    />
  ) : undefined;

  const toolBarAction = isAvailableGetBookingReport ? (
    <BookingReportFilter
      reportPeriod={reportPeriod}
      setReportPeriod={setReportPeriod}
    />
  ) : undefined;

  useUpdateEffect(() => {
    getTableData();
  }, [reportPeriod]);

  return (
    <Table
      showToolbar
      enableSelectAll
      showColumnFilters
      enableStickyHeader
      isLoading={isLoading}
      showGlobalFilter={false}
      rowCount={bookingDataCount}
      toolBarAction={toolBarAction}
      actionsButton={<BookingActionButton />}
      rows={bookingData as unknown as TRow[]}
      className="seller-department__boking-info__table"
      muiTableContainerProps={{ sx: { maxHeight: '600px' } }}
      renderBottomToolbarCustomActions={bottomToolbarCustomActions}
      toolBarStartContent={(
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold' }}
        >
          Booking Table
        </Typography>
      )}
    />
  );
};

export default BookingTable;
